import { Link } from 'react-router-dom';
import logo from 'src/assets/icons/team_cap_icon.svg';
import BellIcon from 'src/assets/images/Bell-icon.svg';
import { noImageUrl } from 'src/constants/index';

type HeaderProps = {
  hideActions?: boolean;
};
const index = ({ hideActions }: HeaderProps) => {
  return (
    <header className="bg-white h-[60px] border-b border-b-[#DCDFE4] pl-6 pr-10 flex justify-between items-center">
      <Link to="/" className="flex items-center gap-[7px]">
        <img src={logo} alt="teamcap logo" className="w-6 h-5" />
        <div className="text-blue-950 text-[25px] font-normal font-Gilroy">
          TeamCap
        </div>
      </Link>
      {!hideActions && (
        <div className="flex gap-5 items-center">
          <img
            src={BellIcon}
            alt="notification icon"
            className="w-[21px] h-5"
          />
          <img
            src={noImageUrl}
            className="rounded-full h-6 w-6"
            alt="user profile"
          />
        </div>
      )}
    </header>
  );
};

export default index;
